// extracted by mini-css-extract-plugin
export var askAiIcon = "_ms-9";
export var container = "_ms-0";
export var groupSeparator = "_ms-a";
export var highlight = "_ms-4";
export var resultIcon = "_ms-5";
export var resultItem = "_ms-7";
export var resultSubtitle = "_ms-3";
export var resultTitle = "_ms-2";
export var resultsList = "_ms-1";
export var searchGroup = "_ms-6";
export var selected = "_ms-8";